import { Component, Inject } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FindingCrudService } from '@core/icr-review/finding-crud.service';
import { MessageToastService } from '@core/messages/message-toast.service';
import { MessageService } from 'primeng/components/common/messageservice';

export interface DialogData {
  term: string;
}

@Component({
  selector: 'bid-modal-findings',
  templateUrl: './modal-findings.component.html',
  styleUrls: ['./modal-findings.component.scss'],
})
export class ModalFindingsComponent {
  icrData;
  selectedTerm: string;
  selectedOptions: string[] = [''];
  terms = [
    { value: '15', viewValue: '15 days' },
    { value: '30', viewValue: '30 days' },
  ];
  formData: FormGroup;
  minDate: Date;
  maxDate: Date;
  constructor(
    public dialogRef: MatDialogRef<ModalFindingsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private findingCrudService: FindingCrudService,
    private messageToastService: MessageToastService,
    private messageService: MessageService,
  ) {
    this.selectedTerm = data.term;
    this.icrData = this.getFindings();
    this.minDate = new Date();
    this.maxDate = new Date(this.minDate);
    this.maxDate.setDate(this.minDate.getDate() + 45);
    if (this.maxDate.getFullYear() > this.minDate.getFullYear()) {
      this.maxDate = new Date(this.minDate);
      this.maxDate.setMonth(11);
      this.maxDate.setDate(31);
    }
  }
  ngOnInit() {
    this.formData = new FormGroup({
      reviewDateRange: new FormControl(''),
    });
  }

  getFindings() {
    const strFindings = localStorage.getItem('saveFindings');
    let json = JSON.parse(strFindings) || [];
    const data = json.filter((item) => {
      return item.isActionMatrix == true;
    });
    return data;
  }

  onCancelClick(): void {
    this.dialogRef.close(false);
  }

  onChange(event): void {
    this.data.term = event.value;
  }

  SaveFinding(): void {
    var analysisId = localStorage.getItem('analysisId');
    var FechaFin = this.formData.value['reviewDateRange'];

    this.findingCrudService.UpdateActionPlan(JSON.parse(analysisId), FechaFin.toJSON()).subscribe(
      (res: any) => {
        if (res === true) {
          this.showToastSuccess('Success', 'Updated Successfully', 'successFormFinding');
        }
      },
      (error) => {
        this.showToastError(
          'An error was encountered when loading the data, please try again later 14',
          'errorMessageicr-review-form',
        );
      },
    );
  }

  showToastSuccess(title, msg, key) {
    this.messageService.add({
      key,
      severity: 'success',
      summary: title,
      detail: msg,
    });
  }

  showToastError(summary, detail) {
    this.messageToastService.showToastError('error', summary, detail);
  }
}
